export { default } from "./useTranslationEventTracking";
export * from "./useTranslationEventTracking";
